import { css } from 'linaria';

export const signaturePrimary = css`
  font-size: 17px;
  font-weight: 700;
  line-height: var(--space-300);
  margin-left: var(--space-50);
`;
export const signatureSecondary = css`
  margin-left: var(--space-25);
`;
export const comma = css`
  margin-right: var(--space-25);
`;

export const primaryPriceView = css`
  height: 32px;
  margin-right: var(--space-200);
  font-weight: 800;
  color: var(--text-primary);
  font-size: 27px;
  line-height: var(--space-400);
`;
export const secondPriceView = css`
  margin-top: var(--space-50);
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--text-primary);
`;
export const subtitleView = css`
  font-weight: 500;
  white-space: nowrap;
  color: var(--text-primary);
`;
export const subtitleViewCurrency = css`
  padding-left: var(--space-25) !important;
`;
export const newPriceContainer = css`
  display: inline-block;
  margin-right: var(--space-200);
  color: var(--secondary-red-primary);
`;
export const textPrimaryStyle = css`
  color: var(--text-primary);
  span {
    color: var(--text-primary);
  }
`;
export const newPriceMainWrap = css`
  font-weight: 700;
  font-size: 27px;
  line-height: 32px;
  display: inline-block;
`;
export const newPriceFractWrap = css`
  display: inline-block;
  position: relative;
  font-weight: 700;
  font-size: 17px;
  line-height: 24px;
`;

export const newCurrencyWrap = css`
  display: inline-block;
  position: relative;
  font-weight: 700;
  font-size: 17px;
  line-height: var(--space-300);
  padding: var(--space-25) var(--space-50) 0 var(--space-25);
`;

export const oldPriceCrossed = css`
  position: relative;
  display: inline;
  line-height: var(--space-250);

  &:after {
    position: absolute;
    top: 50%;
    left: -2px;
    display: block;
    width: 108%;
    height: 1.5px;
    background: var(--secondary-red-primary);
    content: '';
  }
`;

export const miniLine = css`
  line-height: var(--space-175);
`;
export const oldCurrencyWrap = css`
  margin-left: var(--space-25) !important;
  font-size: 13px !important;
  line-height: var(--space-200) !important;
`;

export const oldCurrencyWrapMini = css`
  margin-left: var(--space-25) !important;
`;

export const oldPriceWrapper = css`
  display: flex;
  align-items: flex-start;
  gap: var(--space-100);
  margin-bottom: var(--space-50);
`;

export const bestPriceNameplateContainer = css`
  display: flex;
  margin-bottom: var(--space-100);
`;

export const textStyle = css`
  height: var(--space-250);
  padding: var(--space-60) var(--space-100) var(--space-60) var(--space-125) !important;
  background-color: var(--brand-primary);
  text-transform: uppercase;
  margin-top: auto;
  margin-bottom: auto;
  color: var(--secondary-black);
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 9px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 10px !important;
  letter-spacing: 0.3px !important;
`;

export const discountPercentPlate = css`
  width: max-content;
  overflow: hidden;
  background-color: var(--secondary-red-primary);
  color: var(--text-invert);
  height: var(--space-250);
  display: flex;
  align-items: center;
`;

export const discountPercentPlateText = css`
  display: flex;
  align-items: center;
  width: 20px;
  justify-content: center;
  /* FIXME: Это текущий цвет, который используется для svg, его нет в переменных. Просто перенес.
  Эту плашку будут менять на компонент фронтона. */
  background-color: rgb(184, 40, 37);
  height: 100%;
`;

export const percentValue = css`
  margin-left: 4px;
  z-index: 1;
  margin-right: -2px;
`;
